import React from 'react'
import '../App.css';
import detail from './images/detail-image.png';
import detailMobile from './images/details.png';
import arrow1 from './images/arrow1.png';
import arrow2 from './images/arrow2.png';
import arrow3 from './images/arrow3.png';
import arrow4 from './images/arrow4.png';
import arrow5 from './images/arrow5.png';
import arrow6 from './images/arrow6.png';

export default function Details() {
  return (
    <div>
      <div className='details-container'>
        <div className='detail-content'>
          <div className='details-bg'>

            <img src={detail} className='desktop-image d-none d-md-block' alt="Detail Desktop" />
            <img src={detailMobile} className='mobile-image d-block d-md-none' alt="Detail Mobile" />
          </div>

          <div className='point1'>
            <img src={arrow1} className='arrow1' />
            <ul>
              <li>Expected Delivery Date: <span>Helps in prioritizing orders based on deadlines.</span></li>
            </ul>
          </div>

          <div className='point2'>
            <ul>
              <li>Live Production Status: <span> Instantly track what’s running, what’s delayed, and what’s done.</span></li>
            </ul>
            <img src={arrow2} className='arrow2' />
          </div>

          <div className='point3'>
            <ul>
              <li>Product Type and Model Selection: <span>Tailors the schedule based on BOM and machine requirements.</span></li>
            </ul>
            <img src={arrow3} className='arrow3' />
          </div>

          <div className='point4'>
            <ul>
              <li>Real-Time Updates: <span> Instant visibility into machine availability to prevent scheduling conflicts</span></li>
            </ul>
            <img src={arrow4} className='arrow4' />
          </div>

          <div className='point5'>
            <ul>
              <li>One-Click Submission: <span> Finalize and lock in production schedules with a single action.</span></li>
            </ul>
            <img src={arrow5} className='arrow5' />
          </div>

          <div className='point6'>
            <img src={arrow6} className='arrow6' />
            <ul>
              <li>Comprehensive Order Details: <span> Input fields for Sales Order Number, Date, Customer Information, Product Model, Quantity, and Expected Delivery Date.</span></li>
            </ul>
          </div>

          <div className='point7'>
            <img src={arrow6} className='arrow7' />
            <ul>
              <li>Interactive Calendar View: <span>Visual representation of machine schedules with color-coded indicators </span></li>
            </ul>
          </div>

          <div className='point8'>
            <img src={arrow6} className='arrow8' />
            <ul>
              <li>Intuitive Time Picker: <span>Select precise start and end times for each operation using a user-friendly interface.</span></li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  )
}



























// import React from 'react'
// import '../App.css';
// import detail from './images/detail-image.png'
// import arrow1 from './images/arrow1.png'
// import arrow2 from './images/arrow2.png'
// import arrow3 from './images/arrow3.png'
// import arrow4 from './images/arrow4.png'
// import arrow5 from './images/arrow5.png'
// import arrow6 from './images/arrow6.png'

// export default function Details() {
//   return (
//     <div>


//       <div className='details-container '>
//         <div className='detail-content '>
//           <div className='details-bg '>
//              <img src={detail} className='detail-image'/>
//           </div>
//           <div className='point1'>
//             <img src={arrow1} className='arrow1'/>
//             <ul>
//               <li >Expected Delivery Date: <span>Helps in prioritizing orders based on deadlines.</span></li>
//             </ul>
            
//           </div>
//          <div className='point2'>
//             <ul>
//               <li>Live Production Status: <span> Instantly track what’s running, what’s delayed, and what’s done.</span></li>
//             </ul>
//             <img src={arrow2} className='arrow2'/>
//           </div>
//          <div className='point3'>
//             <ul>
//                <li>Product Type and Model Selection: <span>Tailors the schedule based on BOM and machine requirements.</span></li>
//             </ul> 
            
//             <img src={arrow3} className='arrow3'/>
//           </div>
//            <div className='point4'>
//             <ul>
//               <li>Real-Time Updates: <span> Instant visibility into machine availability to prevent scheduling conflicts</span></li>
//             </ul>
            
//             <img src={arrow4} className='arrow4'/>
//           </div>
//         <div className='point5'>
//             <ul>
//               <li>One-Click Submission:  <span> Finalize and lock in production schedules with a single action.</span></li>
//             </ul>
            
//             <img src={arrow5} className='arrow5'/>
//           </div>
//             <div className='point6'>
//             <img src={arrow6} className='arrow6'/>
//             <ul>
//               <li>Comprehensive Order Details: <span> Input fields for Sales Order Number, Date, Customer Information, Product Model, Quantity, and Expected Delivery Date.</span></li>
//             </ul>
            
//           </div>
//          <div className='point7'>
//             <img src={arrow6} className='arrow7'/>
//             <ul>
//               <li>Interactive Calendar View: <span>Visual representation of machine schedules with color-coded indicators </span></li>
//             </ul>
            
//           </div>
//            <div className='point8'>
//             <img src={arrow6} className='arrow8'/>
//             <ul>
//               <li>Intuitive Time Picker: <span>Select precise start and end times for each operation using a user-friendly interface.</span></li>
//             </ul>
            
//           </div>
           
//         </div>
//       </div>


//     </div>
//   )
// }
